var _get = require('lodash/get')

let v3Settings = [{
        name: 'offline',
        path: 'settings.offline',
        type: 'Boolean'
    },
    {
        name: 'status',
        path: 'settings.status',
        type: 'String'
    },
    {
        name: 'cdn',
        path: 'environment.cdn',
        type: 'Boolean'
    },
    {
        name: 'env',
        path: 'environment.env',
        type: 'String'
    },
    {
        name: 'skinTone',
        path: 'settings.skin_tone',
        type: 'String'
    },
    {
      name: 'engagementCode',
      path: 'settings.code',
      type: 'String'
    },
    {
      name: 'logo',
      path: 'settings.logo',
      type: 'String',
    }
]

export default {
    get: (state, getters, rootState) => (name) => {
        let result, setting
        try {
            setting = state.defaults.find(settings => settings.name === name)
            let selected = state.choices ? state.choices.find(choices => choices.name === name) : undefined

            if (selected) {
                result = selected.value
            }
            else {
                result = setting.selected
            }

            if (setting.type === 'Boolean') {
                result = JSON.parse(result.name.toLowerCase())
            }
        }
        catch (e) {}

        try {
            if (result === undefined) {
                setting = v3Settings.find(x => x.name === name)

                if (setting.type === 'Boolean') {
                    let value = _get(rootState, setting.path, undefined)
                    result = (typeof value === 'boolean') ? value : JSON.parse(value.toLowerCase())
                }

                if (setting.type === 'String') {
                    result = _get(rootState, setting.path, undefined)
                }
            }
        }
        catch (e) {}

        return result
    },

    status: (state, getters, rootState) => {
        return rootState.settings.status
    }
}
